/**
 * Форматирование в разметке. Обёртки над @78/i18n, чтобы не таскать язык
 * через все компоненты и не соблазняться «просто вывести число».
 */

import { useTranslation } from 'react-i18next';
import { CURRENCY, formatDateTime, formatDuration, formatMoney, type Lang } from '@78/i18n';

export function useFmt() {
  const { i18n } = useTranslation();
  const lang = (i18n.language === 'ru' ? 'ru' : 'en') as Lang;
  return {
    lang,
    /** Сумма из нанотонов — одни цифры, без подписи. */
    money: (nano: string | bigint) => formatMoney(BigInt(nano), lang),
    /** Сумма вместе с валютой: подпись не пишется руками нигде. */
    sum: (nano: string | bigint) => `${formatMoney(BigInt(nano), lang)} ${CURRENCY}`,
    dateTime: (unix: number) => formatDateTime(unix, lang),
    duration: (sec: number) => formatDuration(sec, lang),
  };
}

/** Сумма с валютой. Отдельный компонент, чтобы цифры везде выглядели одинаково. */
export function Money({ value, unit = CURRENCY }: { value: string | bigint; unit?: string }) {
  const { money } = useFmt();
  return (
    <span className="num">
      {money(value)} {unit}
    </span>
  );
}
